import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("influcas_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const api = {
  get: (url, cfg) => client.get(url, cfg).then((r) => r.data),
  post: (url, body, cfg) => client.post(url, body, cfg).then((r) => r.data),
  put: (url, body, cfg) => client.put(url, body, cfg).then((r) => r.data),
  delete: (url, cfg) => client.delete(url, cfg).then((r) => r.data),
  raw: client,
};

export function formatErr(detail) {
  if (detail == null) return "Algo salió mal. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
